import { defineMessages } from 'react-intl';

export default defineMessages({
  loadMoreBtnLabel: {
    id: 'CourseDetailsContent.loadMoreBtnLabel',
    defaultMessage: 'Load more',
    description: 'Load more label button displayed in course details',
  },
  courseAuthorsTitle: {
    id: 'CourseDetailsContent.courseAuthorsTitle',
    defaultMessage: 'Course authors',
    description: 'Course authors title displayed in course details',
  },
  completedItemsInSection: {
    id: 'CourseDetailsContent.completedItemsInSection',
    defaultMessage:
      'Completed {completedLessons} lesson(s) and {completedQuizzes} quiz(zes) of {totalLessons} total lesson(s) and {totalQuizzes} total quiz(zes) in the section',
    description: 'Tooltip over number of competed and total section items',
  },
  relatedCoursesLabel: {
    id: 'CourseDetailsContent.relatedCoursesLabel',
    defaultMessage: 'Related courses',
  },
});
